const INVALID_QUERY_PARAM_TEXT = new Set(['', 'null', 'undefined', 'NaN'])

const normalizeQueryText = (value: unknown): string => String(value).trim()

export const isValidQueryValue = (value: unknown): boolean => {
  if (value === null || value === undefined) return false
  const text = normalizeQueryText(value)
  return !INVALID_QUERY_PARAM_TEXT.has(text)
}

export const isValidNumericId = (value: unknown): value is number | string => {
  if (!isValidQueryValue(value)) return false
  const num = Number(normalizeQueryText(value))
  return Number.isFinite(num) && num > 0
}

export const appendQueryParam = (params: URLSearchParams, key: string, value: unknown) => {
  if (!isValidQueryValue(value)) return
  params.set(key, normalizeQueryText(value))
}

export const appendIdParam = (params: URLSearchParams, key: string, value: unknown) => {
  if (!isValidNumericId(value)) return
  params.set(key, String(Number(normalizeQueryText(value))))
}

export const buildQueryString = (params: URLSearchParams): string => params.toString()
